import { Typography } from '@mui/material';
import {
  MembershipPlansPreview,
  type MembershipPlansPreviewConfig,
} from '@provision/membership-plans-ui';
import {
  PreviewContainer,
  PreviewContent,
  PreviewPlaceholder,
} from 'src/pages/Settings/memberships/styled';
import {
  previewBodySecondarySx,
  previewBodyTertiarySx,
} from 'src/pages/Settings/memberships/styles';

/** Support image shown in the membership preview contact block (matches Client Gateway). */
const PREVIEW_SUPPORT_IMAGE_URL =
  'https://images.unsplash.com/photo-1758599543154-76ec1c4257df?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHBlcnNvbiUyMGhlYWRzaG90fGVufDF8fHx8MTc2MjMzOTkzN3ww&ixlib=rb-4.1.0&q=80&w=1080';

type MembershipsConfigPreviewProps = {
  config: MembershipPlansPreviewConfig | null;
  branding: { primaryColor: string; secondaryColor: string };
  backgroundImageUrl?: string;
};

export const MembershipsConfigPreview = ({
  config,
  branding,
  backgroundImageUrl,
}: MembershipsConfigPreviewProps) => (
  <PreviewContainer backgroundImageUrl={backgroundImageUrl}>
    <PreviewContent>
      {config ? (
        <MembershipPlansPreview
          config={config}
          title="Activation Flow Preview"
          subtitle="This is how your membership plans will appear to clients"
          showFaq
          showSetupCheckoutHint
          showContactSupport
          supportImageUrl={PREVIEW_SUPPORT_IMAGE_URL}
          isContinueDisabled={false}
          branding={branding}
        />
      ) : (
        <PreviewPlaceholder>
          <Typography variant="h4" gutterBottom fontWeight={700}>
            Activation Flow Preview
          </Typography>
          <Typography variant="body1" sx={previewBodySecondarySx}>
            Select a client segment and load or create a configuration to see the preview.
          </Typography>
          <Typography variant="body2" sx={previewBodyTertiarySx}>
            Use the configuration panel to customize your membership plans, features, and
            settings.
          </Typography>
        </PreviewPlaceholder>
      )}
    </PreviewContent>
  </PreviewContainer>
);
